import img from "../../images/5A3_Familia.jpg";
import img1 from "../../images/5B4_Bobbins by Craig Holmes.jpg"
import img5 from "../../images/Teotitlan shoot-by nikhol esteras.jpg"
import img6 from "../../images/5A2_Porfirio_Gutierrez_by_recker.jpg"
import img7 from "../../images/PGOAX82718-0242.jpg"

export const photos = [
    {
      src: img1,
      width: 1,
      height: 1
    },
    {
      src: img1,
      width: 1,
      height: 1
    },
    {
      src: img7,
      width: 1,
      height: 1
    },
    {
      src: img6,
      width: 1,
      height: 1
    },
    {
      src: img6,
      width: 1,
      height: 1
    },
    {
      src: img5,
      width: 1,
      height: 1
    },
    {
      src: img6,
      width: 1,
      height: 1
    },
    {
      src: img7,
      width: 1,
      height: 1
    },
    {
      src: img,
      width: 1,
      height: 1
    },
    {
      src: "https://source.unsplash.com/zh7GEuORbUw/600x799",
      width: 1,
      height: 1
    },
    {
      src: "https://source.unsplash.com/PpOHJezOalU/800x599",
      width: 1,
      height: 1
    },
    {
      src: img,
      width: 1,
      height: 1
    },
    {
      src: "https://source.unsplash.com/zh7GEuORbUw/600x799",
      width: 1,
      height: 1
    },
    {
      src: "https://source.unsplash.com/PpOHJezOalU/800x599",
      width: 1,
      height: 1
    },
    {
      src: img,
      width: 1,
      height: 1
    }
  ];
  